// Translations
import form from '../sections/form/translations/ru'

// Translation: Reset > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
